import InputBase from './InputBase';

export type { InputBaseProps, InputBaseCommonProps, InputBaseLocaleType } from './InputBase';
export default InputBase;
